import { useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import { useSimplifiedSignupModalContext } from '@/context/SimplifiedSignupModalContextProvider';
import { useUpsellBannerContent } from '@/hooks/app/useUpsellBannerContent/useUpsellBannerContent';

import { useSimplifiedSignupContext } from '../SimplifiedSignup/Context';
import messages from './messages';
import {
	ChevronRightCenterd,
	Family,
	IconAndCopyWrapper,
	Time,
	TimeIconWrapper,
	UpsellBannerWrapper,
} from './styles';

const UpsellBanner = () => {
	const { formatMessage } = useIntl();
	const { upsellCopy, config, onClick, isFamilyPlanUpsellBannerEligible } = useUpsellBannerContent();
	const { isModalOpen, setIsModalOpen } = useSimplifiedSignupModalContext();
	const { setFlowConfig } = useSimplifiedSignupContext();

	function _onClick() {
		if (!isModalOpen) {
			setFlowConfig(config);
			setIsModalOpen(true);
		}
	}

	const onClickAction = async () => {
		if (isFamilyPlanUpsellBannerEligible) {
			await onClick();
			return;
		}

		_onClick();
	};

	if (!upsellCopy) {
		return null;
	}

	return (
		<UpsellBannerWrapper
			aria-label={formatMessage(messages.upsellBannerAriaLabel)}
			tabIndex={0}
			role="button"
			onClick={onClickAction}
		>
			<IconAndCopyWrapper>
				<TimeIconWrapper>{isFamilyPlanUpsellBannerEligible ? <Family /> : <Time />}</TimeIconWrapper>
				<Text color="white" size={FontSizes.base} weight={FontWeights.Medium} noMargin>
					{formatMessage(upsellCopy)}
				</Text>
			</IconAndCopyWrapper>
			<ChevronRightCenterd />
		</UpsellBannerWrapper>
	);
};

export default UpsellBanner;
